const TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const DATA_KEY = "login_data";

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  saveToken(accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken);
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  saveRefreshToken(refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  removeRefreshToken() {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },
};

const TokenServiceApp = {
  getToken() {
    return localStorage.getItem(DATA_KEY);
  },

  saveToken(data) {
    localStorage.setItem(DATA_KEY, data);
  },

  removeToken() {
    localStorage.removeItem(DATA_KEY);
  },
};

const UserIdService = {
  getUserId() {
    return localStorage.getItem(user_id);
  },

  saveUserId(data) {
    localStorage.setItem("user_id", data);
  },

  removeUserId() {
    localStorage.removeItem(user_id);
  },
};

const LocationId = {
  setLocationId(val) {
    localStorage.setItem("LOCATION_ID", JSON.stringify(val));
  },
  getLocationId() {
    return JSON.parse(localStorage.getItem("LOCATION_ID"));
  },
};

const UserDetail = {
  setLoggedUser(val) {
    localStorage.setItem("KHAANPIN_USER", JSON.stringify(val));
  },
  getLoggedUser() {
    return JSON.parse(localStorage.getItem("KHAANPIN_USER"));
  },
};

const CartData = {
  setCartItems(val) {
    localStorage.setItem("CART_CONTENT", JSON.stringify(val));
  },
  getCartItems() {
    return JSON.parse(localStorage.getItem("CART_CONTENT"));
  },
  removeCartItems() {
    return localStorage.removeItem("CART_CONTENT");
  },
  setCartTotal(val) {
    localStorage.setItem("CART_TOTAL", JSON.stringify(val));
  },
  getCartTotal() {
    return JSON.parse(localStorage.getItem(" "));
  },
  removeCartTotal() {
    return localStorage.removeItem("CART_TOTAL");
  },
  setOrderId(val) {
    localStorage.setItem("ORDER_ID", JSON.stringify(val));
  },
  getOrderId() {
    return JSON.parse(localStorage.getItem("ORDER_ID"));
  },
  removeOrderId() {
    return localStorage.removeItem("ORDER_ID");
  },
  setDeliveryCharge(val) {
    localStorage.setItem("DELIVERY_CHARGE", JSON.stringify(val));
  },
  getDeliveryCharge() {
    return JSON.parse(localStorage.getItem("DELIVERY_CHARGE"));
  },
  removeDeliveryCharge() {
    return localStorage.removeItem("DELIVERY_CHARGE");
  },
  setExtCardId(val) {
    localStorage.setItem("EXT_CART_ID", JSON.stringify(val));
  },
  getExtCartId() {
    return JSON.parse(localStorage.getItem("EXT_CART_ID"));
  },
  removeExtCartId() {
    return localStorage.removeItem("EXT_CART_ID");
  },
  setExtCartAmount(val) {
    localStorage.setItem("ORDER_AMOUNT", JSON.stringify(val));
  },
  getExtCartAmount() {
    return JSON.parse(localStorage.getItem("ORDER_AMOUNT"));
  },
  removeExtCartAmount() {
    return localStorage.removeItem("ORDER_AMOUNT");
  },
  setCartAmount(val) {
    localStorage.setItem("GRAND_TOTAL", JSON.stringify(val));
  },
  getCartAmount() {
    return JSON.parse(localStorage.getItem("GRAND_TOTAL"));
  },
  removeCartAmount() {
    return localStorage.removeItem("GRAND_TOTAL");
  },
};

const FonePayInfo = {
  setPRN(val) {
    localStorage.setItem("FP_PRN", JSON.stringify(val));
  },
  getPRN() {
    return JSON.parse(localStorage.getItem("FP_PRN"));
  },
  clearPRN() {
    localStorage.removeItem("FP_PRN");
  },
  setExtPRN(val) {
    localStorage.setItem("FP_EXT_PRN", JSON.stringify(val));
  },
  getExtPRN() {
    return JSON.parse(localStorage.getItem("FP_EXT_PRN"));
  },
  clearExtPRN() {
    localStorage.removeItem("FP_EXT_PRN");
  },
  setTransactionId(val) {
    localStorage.setItem("TRANS_ID", JSON.stringify(val));
  },
  getTransactionId() {
    return JSON.parse(localStorage.getItem("TRANS_ID"));
  },
  clearTransactionId() {
    localStorage.removeItem("TRANS_ID");
  },
  setOrderId(val) {
    localStorage.setItem("ORDER_ID", JSON.stringify(val));
  },
  getOrderId() {
    return JSON.parse(localStorage.getItem("ORDER_ID"));
  },
  clearOrderId() {
    localStorage.removeItem("ORDER_ID");
  },
};

export {
  TokenService,
  TokenServiceApp,
  LocationId,
  UserDetail,
  CartData,
  FonePayInfo,
  UserIdService
};
